import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom"; 
import logo from "../assets/images/pfs_icon.png";
import "./Navbar.css"; // CSS opcional para mejorar estilos

function Navbar({ hideNavbar }) {   
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  if (hideNavbar) return null;
  // Comprobar si el usuario está autenticado
  const isAuthenticated = !!localStorage.getItem("access_token");

   // Función para manejar el logout
  const handleLogout = () => {
    localStorage.removeItem("access_token"); // Eliminar token del almacenamiento local
    localStorage.removeItem("refresh_token"); // Opcional: eliminar refresh token
    navigate("/login"); // Redirigir al login
    // setShowMenu(!showMenu) // Ocultamos el menu lateral
  };
  
  const toggleMenu = () => setShowMenu(!showMenu);
  
  return (
    <>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container">
          {/* Logo */}
          <Link className="navbar-brand d-flex align-items-center" to="/">
            <img src={logo} alt="Logo" style={{ height: "40px" }} className="me-2" />
            <span className="fw-bold">Pathfinder Madrid</span>
          </Link>
          <div className="flex justify-center">
            {/* WhatsApp */}
            <a
              href="https://chat.whatsapp.com/ECUy5iRmxTAIxoxWrTAFFX?mode=ac_t"
              target="_blank"
              rel="noopener noreferrer"              
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="#fff"
                style={{ width: "32px", height: "32px", marginRight: "10px" }}
              >
                <path d="M24 4C12.95 4 4 12.95 4 24c0 4.24 1.24 8.16 3.38 11.5L4 44l9.02-3.28C16.06 42.5 19.93 44 24 44c11.05 0 20-8.95 20-20S35.05 4 24 4zm0 36c-3.42 0-6.6-1.03-9.27-2.78l-.66-.43-5.36 1.95 1.91-5.45-.43-.69C8.96 29.54 8 26.85 8 24c0-8.84 7.16-16 16-16s16 7.16 16 16-7.16 16-16 16zm8.69-11.5c-.47-.23-2.79-1.38-3.22-1.54-.43-.16-.74-.23-1.06.23-.31.46-1.22 1.54-1.5 1.85-.27.31-.55.35-1.02.12-.47-.23-1.98-.73-3.77-2.32-1.39-1.24-2.32-2.77-2.59-3.24-.27-.47-.03-.72.2-.95.21-.21.47-.55.7-.83.23-.27.31-.46.47-.77.15-.31.08-.58-.04-.81-.12-.23-1.06-2.55-1.45-3.5-.38-.92-.77-.79-1.06-.8l-.91-.01c-.31 0-.81.12-1.24.58-.43.46-1.63 1.6-1.63 3.9s1.67 4.52 1.9 4.83c.23.31 3.28 5 7.94 7.01 1.11.48 1.97.77 2.64.99 1.11.35 2.12.3 2.92.18.89-.13 2.79-1.14 3.18-2.24.39-1.1.39-2.04.27-2.24-.12-.19-.43-.31-.91-.54z" />
              </svg>
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/pfsmadrid/"
              target="_blank"
              rel="noopener noreferrer"              
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="#fff"
                style={{ width: "32px", height: "32px" }}
              >
                <path d="M34 4H14C8.48 4 4 8.48 4 14v20c0 5.52 4.48 10 10 10h20c5.52 0 10-4.48 10-10V14c0-5.52-4.48-10-10-10zm6 30c0 3.31-2.69 6-6 6H14c-3.31 0-6-2.69-6-6V14c0-3.31 2.69-6 6-6h20c3.31 0 6 2.69 6 6v20z" />
                <path d="M24 14c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm0 16.2c-3.42 0-6.2-2.78-6.2-6.2s2.78-6.2 6.2-6.2 6.2 2.78 6.2 6.2-2.78 6.2-6.2 6.2zM34.5 13.5c0 .83-.67 1.5-1.5 1.5S31.5 14.33 31.5 13.5 32.17 12 33 12s1.5.67 1.5 1.5z" />
              </svg>
            </a>
          </div>

          {/* Botón hamburguesa (visible solo en resoluciones pequeñas) */}
          <button
            className="btn btn-dark d-block d-md-none"
            type="button"
            onClick={toggleMenu}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Menú principal (visible en resoluciones grandes) */}
          <div className="collapse navbar-collapse d-none d-lg-flex" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">Inicio</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/events/">Eventos</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/organizedplay">Juego Organizado</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">Contacto</Link>
              </li>
              {/* Mostrar enlaces según autenticación */}
              {!isAuthenticated ? (
              <>
              <li className="nav-item">
                <Link className="nav-link" to="/register">Registro</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/login">Iniciar Sesión</Link>
              </li> 
              </>
              ) : (
              <>
              <li className="nav-item">
                  <Link className="nav-link" to="/dashboard"> Panel de Usuario</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/login" onClick={handleLogout}>Cerrar Sesión</Link>
              </li>
              </>
              )}
            </ul>
          </div>
        </div>
      </nav>

      {/* Offcanvas Menu (visible solo en resoluciones pequeñas) */}
      <div className={`offcanvas offcanvas-end ${showMenu ? "show" : ""}`} style={{ visibility: showMenu ? "visible" : "hidden" }}>
        <div className="offcanvas-header">
          <Link className="navbar-brand d-flex align-items-center" to="/">
            <img src={logo} alt="Logo" style={{ height: "40px" }} className="me-2" />
            <span className="fw-bold">Pathfinder Madrid</span>            
          </Link>
          
          <button type="button" className="btn-close btn-close-white me-1" onClick={toggleMenu}></button>
        </div>
        <div className="offcanvas-body">
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link className="nav-link" to="/" onClick={toggleMenu}>Inicio</Link>
            </li>            
            <li className="nav-item">
              <Link className="nav-link" to="/events/" onClick={toggleMenu}>Eventos</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/organizedplay/" onClick={toggleMenu}>Juego Organizado</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact" onClick={toggleMenu}>Contacto</Link>
            </li>
            {!isAuthenticated ? (
            <>
            <li className="nav-item">
              <Link className="nav-link" to="/register" onClick={toggleMenu}>Registro</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/login" onClick={toggleMenu}>Iniciar Sesión</Link>
            </li>
            </>
            ) : (
            <>
            <li className="nav-item">
              <Link className="nav-link" to="/dashboard" onClick={toggleMenu}>Panel de Usuario</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/login" onClick={handleLogout}>Cerrar Sesión</Link>
            </li>
            </>
            )}
          </ul>
          
        </div>
      </div>
    </>
  );
}

export default Navbar;
